export default {
  Offer: {
    AbodeProPlan: 'AbodeProPlan',
    ConnectedHome: 'ConnectedHome',
    NewConnectedHomeSignUpCustomer: 'NewConnectedHomeSignUpCustomer',
    PriorQuoteWithSelfReportedUWFlags: 'PriorQuoteWithSelfReportedUWFlags',
    OfferNeedsUWReviewForHome: 'OfferNeedsUWReviewForHome'
  },
  Policy: {
    CrossSellEligibility: 'CrossSellEligibility',
    SignedConversionDocuments: 'SignedConversionDocuments',
    PendingThirdPartyPurchases: 'PendingThirdPartyPurchases'
  },
  Customer: {
    CrossSellEligibility: 'CrossSellEligibility'
  }
};
